var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 408.785 408.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.699 0H55.085A55.085 55.085 0 0 0 0 55.085v298.616a55.084 55.084 0 0 0 55.084 55.085h147.275l63.71.002h87.632a55.083 55.083 0 0 0 55.084-55.083V55.085A55.086 55.086 0 0 0 353.699 0M141.373 314.731h-49.49V165.836h49.49zm-24.744-169.227h-.323c-16.608 0-27.349-11.432-27.349-25.72 0-14.611 11.07-25.727 28-25.727s27.349 11.116 27.67 25.727c0 14.288-10.74 25.72-27.998 25.72m203.198 169.227h-49.485v-79.655c0-20.019-7.165-33.671-25.073-33.671-13.67 0-21.813 9.209-25.392 18.099-1.308 3.181-1.627 7.628-1.627 12.078v83.149h-49.488s.647-134.926 0-148.895h49.488v21.082c6.576-10.145 18.344-24.576 44.6-24.576 32.562 0 56.977 21.28 56.977 67.013z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.8e8d381c8bb9ba8dab1bcd9cba00f64e.svg";
export { ForwardRef as ReactComponent };